export const EXPERT_BANNER_TYPE = {
    BRIEF: 'brief',
    PROJECT_PARTNERS: 'project partners',
    AI_CONSULTATION: 'ai_consultation',
};
